




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ReviewStat extends Vue {
  @Prop({ default: 'Review Title' })
  title!: string;
  @Prop({ default: 'Review Message' })
  message!: string;
  @Prop({ default: 'icon-play' })
  iconName!: string;
}
